import { inject, Injectable } from '@angular/core';
import { API_CONFIG, ApiCallingV2Service } from '@zayan-erp/shared';
import { Observable } from 'rxjs';

export interface IReadSubcategories {
  id: string;
  productListId: string;
  categoryId: string;
  description: string;
  code: string;
  isActive: boolean;
  category: IReadSubcategoriesCategory;
  attributes: null;
  image: IReadSubcategoriesCategoryImage | null;
}

export interface IReadSubcategoriesCategory {
  id: string;
  productListId: string;
  description: string;
  code: string;
  isActive: boolean;
}

export interface IReadSubcategoriesCategoryImage {
  id: string;
  s3Key: string;
  directUrl: string;
}
@Injectable({
  providedIn: 'root'
})
export class ProductSubcategoriesService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  readSubcategories(
    productListId?: string | null,
    categoryId?: string | null,
    showLoader = true
  ): Observable<IReadSubcategories[]> {
    const qs = [
      productListId && `productListId=${productListId}`,
      categoryId && `categoryId=${categoryId}`,
      'isActive=true'
    ]
      .filter(Boolean)
      .join('&');
    return this.#http.getData(`${this.baseUrl}/subcategories?${qs}`, {
      showLoader: showLoader ?? true,
      showMessage: false
    });
  }

  readSubcategoriesByProductListIdAndCategoryId(productListId: string, categoryId: string): Observable<any> {
    return this.#http.getData(
      `${this.baseUrl}/products/subcategories?productListId=${productListId}&categoryId=${categoryId}`,
      { showLoader: true, showMessage: false }
    );
  }

  readSubcategoriesById(id: string): Observable<any> {
    return this.#http.getData(`${this.baseUrl}/subcategories/${id}`, { showLoader: true, showMessage: false });
  }

  createSubcategories(subcategories: any): Observable<any> {
    return this.#http.postData(
      `${this.baseUrl}/products/categories/${subcategories.categoryId}/sub-categories`,
      { showLoader: true, showMessage: true },
      subcategories
    );
  }

  updateSubcategories(subcategories: any): Observable<any> {
    return this.#http.putData(`${this.baseUrl}/subcategories/${subcategories.id}`, subcategories, {
      showLoader: true,
      showMessage: true
    });
  }

  deleteSubcategories(id: string): Observable<any> {
    return this.#http.deleteData(`${this.baseUrl}/subcategories/${id}`, { showLoader: true, showMessage: true });
  }
}
